import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full min-h-[500px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20atmospheric%20interior%20scene%20with%20soft%20golden%20hour%20lighting%2C%20cozy%20reading%20nook%20with%20floating%20illustration%20panels%2C%20dreamy%20bokeh%20effect%2C%20artistic%20abstract%20composition%20with%20cream%20and%20warm%20beige%20tones%2C%20Korean%20aesthetic%20inspired%2C%20soft%20focus%2C%20no%20people%2C%20elegant%20atmosphere&width=1800&height=900&seq=cta-bg-2026&orientation=landscape"
        alt="开启韩漫阅读之旅"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-black text-background-50 tracking-wide mb-6">
            准备好开始了吗？
          </h2>
          <p className="text-base md:text-lg text-background-200 max-w-xl mx-auto mb-4 leading-relaxed">
            数千部精选韩漫等你来发现
          </p>
          <p className="text-sm md:text-base text-background-300 max-w-xl mx-auto mb-10 leading-relaxed">
            无论你喜欢甜蜜恋爱还是热血冒险，这里都有属于你的故事
          </p>

          <Link
            to="/category/romance"
            className="inline-flex items-center gap-3 bg-black text-background-50 px-8 py-4 rounded-full text-sm font-semibold hover:bg-foreground-900 transition-all duration-300 whitespace-nowrap cursor-pointer group"
          >
            <span className="w-8 h-8 rounded-full bg-accent-500 flex items-center justify-center">
              <i className="ri-book-open-line text-background-50 text-sm"></i>
            </span>
            立即开始阅读
            <i className="ri-arrow-right-up-line group-hover:rotate-45 transition-transform duration-300"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}